module.exports = __webpack_public_path__ + "img/CR09EU.6fa6cbc1.png";